import { AppServices } from '@singularsystems/neo-core';
import { AppService, CommonTypes } from "st-common/App/CommonTypes";
import ProxySessionService from './Services/ProxySessionService';

import { IAcceptTermsAndConditionsApiClient } from './ApiClients/Custom/TermsAndConditions/AcceptTermsAndConditionsApiClient';
import { ITermsAndConditionsDisplayOptionsApiClient } from './ApiClients/Custom/TermsAndConditions/TermsAndConditionsDisplayOptionsApiClient';
import { IProxySessionQueryApiClient } from './ApiClients/Custom/ProxyUsers/ProxySessionQueryApiClient';
import { IProxySessionApiClient } from './ApiClients/Custom/ProxyUsers/ProxySessionApiClient';
import { IAccountApiClient } from './ApiClients/AccountApiClient';

import { CommonIdentitySharedTypes } from "./CommonIdentitySharedTypes";

const CommonIdentityTypes = {
    ApiClients: {
        AccountApiClient: new AppServices.ServiceIdentifier<IAccountApiClient>("Identity.ApiClients.AccountApiClient"),
        ProxySessionQueryApiClient: new AppServices.ServiceIdentifier<IProxySessionQueryApiClient>("Identity.ApiClients.ProxySessionQueryApiClient"),
        ProxySessionApiClient: new AppServices.ServiceIdentifier<IProxySessionApiClient>("Identity.ApiClients.ProxySessionApiClient"),
        AcceptTermsAndConditionsApiClient: new AppServices.ServiceIdentifier<IAcceptTermsAndConditionsApiClient>("Identity.ApiClients.AcceptTermsAndConditionsApiClient"),
        TermsAndConditionsDisplayOptionsApiClient: new AppServices.ServiceIdentifier<ITermsAndConditionsDisplayOptionsApiClient>("Identity.ApiClients.TermsAndConditionsDisplayOptionsApiClient"),
    },
    Services: {
        ...CommonIdentitySharedTypes.Services,
        ProxySessionService: new AppServices.ServiceIdentifier<ProxySessionService>("Identity.Services.ProxySessionService"),
    },
}

const Types = {
    ...CommonTypes,
    Identity: CommonIdentityTypes,
}

export { AppService, Types, CommonIdentityTypes }